import { PessoaModel } from "api/cardapio/models/pessoa/pessoa-model"
import { useGetPessoas } from "api/cardapio/queries/pessoa/get-pessoas"
import { useCallback } from "react"
import { useDadosDeliveryStore } from "services/store/dados-delivery"
import { useObterToken } from "services/store/obter-token"
import { usePessoaUsuarioStore } from "services/store/pessoa-usuario"
import { getIDFromUrl } from "utils/get-id-url"
import { guidEmpty } from "utils/guid-empty"
import { ConvertTokenIntegrador } from "utils/use-token"

export const usePessoaUsuario = () => {
    const { getPessoas, carregando } = useGetPessoas()
    const { setPessoa } = usePessoaUsuarioStore()
    const { setEnderecoDelivery, enderecoDelivery, setTipoDelivery } = useDadosDeliveryStore()
    const { token: tokenUsuario, isTokenExpired } = useObterToken()

    const carregarPessoa = useCallback(async (tokenParam?: string) => {
        const token = tokenParam || tokenUsuario || ''
        try {
            if (!token || isTokenExpired(token)) {
                if (enderecoDelivery?.pessoaId !== guidEmpty()) {
                    setEnderecoDelivery(undefined)
                    setTipoDelivery(undefined)
                }
                setPessoa(undefined)
                return
            }
            const usuarioToken = ConvertTokenIntegrador(token)
            const empresaId = getIDFromUrl('empresaId')
            const res = await getPessoas(`?usuarioId=${usuarioToken?.jti}`, empresaId)
            if (res.erro) throw res.erro
            const resultado = res.resultado?.data as PessoaModel
            setPessoa(resultado)
        } catch (error) {
            console.log(error)
        }
    }, [enderecoDelivery?.pessoaId, getPessoas, isTokenExpired, setEnderecoDelivery, setPessoa, setTipoDelivery, tokenUsuario])

    return {
        carregarPessoa,
        carregando
    }
}